import React from 'react';

import Button from '@lib/button/button.jsx';
import LetterTile from '@widgets/letter-tile.jsx';
import LoadSpinner from '@widgets/load-spinner.jsx';

import NavigationIcon from '../navigation-icon.jsx';

import styles from './group-logo.module.css';
import Dropdown from '@lib/dropdown/dropdown';

export default class GroupLogo extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
    };

    this.selfRef = React.createRef();

    this.handleInfo = this.handleInfo.bind(this);
  }

  handleInfo() {
    if (this.props.onInfo) {
      this.props.onInfo();
    }
  }

  isMenuEmpty() {
    const isMenuHasLinks =
      this.props.navigationItems && this.props.navigationItems.length > 0 && window.innerWidth <= 880;
    return !isMenuHasLinks && !this.props.isAdmin;
  }

  render() {
    const topic = this.props.topic || {};

    return (
      <Dropdown
        open={this.state.menuOpen}
        onOpenChange={menuOpen => this.setState({ menuOpen })}
        disabled={this.isMenuEmpty()}
        className={styles.topic}
        menuClassName={styles.topicMenu}
        trigger={({ open, disabled, onClick }) => (
          <Button className={styles.topicButton} active={open} onClick={onClick} disabled={disabled}>
            <div className={styles.avatarBox}>
              <LetterTile
                authorizeURL={topic.authorizeURL}
                avatar={topic.avatar || true}
                topic={topic.id}
                title={topic.title}
              />
            </div>

            <div className={styles.topicText}>
              <span className={styles.topicTitle}>{topic.title}</span>
              <LoadSpinner show={this.props.loading || !topic.subtitle} className={styles.spinner} />
              {topic.subtitle ? <span className={styles.topicSubtitle}>{topic.subtitle}</span> : null}
            </div>
          </Button>
        )}
      >
        {this.props.isAdmin ? (
          <div className={styles.menuItems}>
            <Button className={styles.menuItem} disabled={!topic.id} onClick={this.handleInfo}>
              <i className="material-icons">info</i>
              <span>{this.props.infoLabel}</span>
            </Button>
          </div>
        ) : null}

        <div className={styles.mobileLinks}>
          {this.props.navigationItems
            ? this.props.navigationItems.map(item => (
                <a
                  className={styles.menuItem}
                  key={item.key}
                  href={item.href}
                  target={item.external ? '_blank' : '_self'}
                  rel={item.external ? 'noopener' : ''}
                >
                  <NavigationIcon name={item.key} className={styles.linkIcon} />
                  <span>{item.label}</span>
                </a>
              ))
            : null}
        </div>
      </Dropdown>
    );
  }
}
